import {  Role } from "../Model/userObjects";

export const OWN_ROLE = "OWN_ROLE";

const initialState = new Role({}); 

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case OWN_ROLE:
            return action.payload;
        default:
            return state;
    }
}

const storeName = "ownRole"

const storeMapping = {[storeName]: reducer};

export const ownRoleSelector = (state) => state[storeName];
export const ownPermissionsSelector = (state) => state[storeName].getPermissions();

export default storeMapping;
